import './App.css';
import Screen from './Screen';

function App() {
  return (
    <div className="App">
      <Screen />
    </div>
  );
}

export default App;
